import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaGlobe, FaClock, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import logo from '../assets/images/logo.jpg';
import '../styles/header.css';

const Header = ({ language, onLanguageChange }) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const navText = {
    home: { en: 'Home', am: 'መነሻ ገጽ' },
    rooms: { en: 'Rooms', am: 'ክፍሎች' },
    about: { en: 'About', am: 'ስለእኛ' },
    services: { en: 'Services', am: 'አገልግሎቶች' },
    news: { en: 'Events and News', am: 'መረጃ እና ዜና' },
    contact: { en: 'Contact Us', am: 'ያግኙን' },
  };

  // Keep concise and aligned with primary site links
  const serviceLinks = [
    { path: '/rooms', text: { en: 'Rooms', am: 'ክፍሎች' } },
    { path: '/bar', text: { en: 'Dining', am: 'ሬስቶራንት' } },
    { path: '/conference', text: { en: 'Meeting & Events', am: 'ስብሰባ እና ዝግጅቶች' } },
    { path: '/bar', text: { en: 'Bar & Lounge', am: 'ባር እና ላውንጅ' } },
  ];

  return (
    <header className="hotel-header">
      {/* Top Info Bar */}
      <div className="topbar">
        <div className="container-fluid d-flex justify-content-between align-items-center topbar-inner">
          <div className="d-flex align-items-center gap-3 topbar-left">
            <a href="tel:+251911123456" className="topbar-link">
              <FaPhoneAlt className="me-1" /> +251930802323  +251930802326
              
            </a>
            <a href="mailto:info@bluenesthotel.com" className="topbar-link">
              <FaEnvelope className="me-1" /> bluebesthotelsocials@gmail.com
            </a>
          </div>
          <div className="d-flex align-items-center gap-2 topbar-right">
            <FaClock /> <span>24/7</span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="navbar navbar-expand-lg main-navbar">
        <div className="container-fluid">
          {/* Mobile left: brand */}
          <NavLink className="navbar-brand d-lg-none mx-auto" to="/">
            <img src={logo} alt="Blue Nest Hotel" className="brand-logo" />
          </NavLink>

          <button
            className={`navbar-toggler ${!isNavCollapsed ? 'open' : ''}`}
            type="button"
            onClick={handleNavCollapse}
            aria-controls="navbarNav"
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
            <div className="navbar-content w-100 d-flex align-items-center justify-content-center">
              {/* Left nav */}
              <ul className="navbar-nav align-items-lg-center header-nav-left-mid">
                <li className="nav-item"><NavLink to="/" className="nav-link" end>{navText.home[language]}</NavLink></li>
                <li className="nav-item"><NavLink to="/rooms" className="nav-link" end>{navText.rooms[language]}</NavLink></li>
                <li className="nav-item"><NavLink to="/about" className="nav-link" end>{navText.about[language]}</NavLink></li>
                {/* Services after About */}
                <li className="nav-item dropdown">
                  <button className="nav-link dropdown-toggle btn btn-link p-0" id="servicesDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    {navText.services[language]}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="servicesDropdown">
                    {serviceLinks.map((link, index) => (
                      <li key={`s-${index}`}>
                        <NavLink className="dropdown-item" to={link.path}>{link.text[language]}</NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>

              {/* Center logo on desktop */}
              <div className="brand-center d-none d-lg-flex">
                <NavLink to="/" className="navbar-brand">
                  <img src={logo} alt="Blue Nest Hotel" className="brand-logo" />
                </NavLink>
              </div>

              {/* Right nav */}
              <ul className="navbar-nav align-items-lg-center header-nav-right-mid">
                <li className="nav-item"><NavLink to="/news-events" className="nav-link" end>{navText.news[language]}</NavLink></li>
                <li className="nav-item"><NavLink to="/contact" className="nav-link" end>{navText.contact[language]}</NavLink></li>
                <li className="nav-item">
                  <button onClick={onLanguageChange} className="btn btn-lang">
                    <FaGlobe className="me-2" /> {language === 'en' ? 'አማ' : 'EN'}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
